import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import deliverService from '../../services/DeliveringService';
import { t } from '../../services/i18nService';
import sessionReader from '../../store/readHelpers/SessionReader';
import timeReader from '../../store/readHelpers/TimeReader';
import apiReader from '../../store/readHelpers/ApiReader';
import deliveringActions from '../../actions/DeliveringActions';
import responseSendingQueue from '../../services/ResponseSendingQueue';
import storeManager from '../../store/StoreManager';
import DeliverButton from './DeliverButton';

import styles from './submitAssessment.scss';
import environmentNames from '../../environmentNames';
import navigationService from '../../services/NavigationService';
import parentTestService from '../../services/ParentTestService';

class SubmitAssessment extends React.Component {
    static propTypes = {
        deliveringState: PropTypes.object.isRequired,
        hasUnsavedUserResponses: PropTypes.bool.isRequired,
        isOnline: PropTypes.bool.isRequired,
        noAttemptedQuestions: PropTypes.bool.isRequired,
        timeHasExpired: PropTypes.bool,
        ui: PropTypes.object,
    };

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillMount() {
        storeManager
            .getStore()
            .dispatch(
                deliveringActions.resetDeliveringState()
            );
        responseSendingQueue
            .getInstance()
            .resetWaitCount();
    }

    componentDidMount() {
        this.checkResponseState();
    }

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.hasUnsavedUserResponses !== nextProps.hasUnsavedUserResponses) {
            this.checkResponseState();
        }
    }

    checkResponseState = () => {
        if (!sessionReader.isContextExam()) {
            return;
        }

        if (apiReader.hasUnsavedUserResponses()) {
            window.console.log('Not all user responses are stored on the server');
            return;
        }

        deliverService.checkForResponseState2ServerDifferences();
    };

    stubDeliverChildTest = () => {
        navigationService.navigateToTestOverview();
        parentTestService.unsetChildIdentifiers();
    };

    render() {
        const { deliveringState, hasUnsavedUserResponses, noAttemptedQuestions, isOnline, timeHasExpired, ui } = this.props;
        const isPreview = sessionReader.isContextPreview();
        const buttonsDisabled = isPreview || (deliveringState.hasDelivered === true);
        const btnActiveClassName = `btn ${styles.activeButton}`;
        const showDeliverButton = (deliveringState.responseVerificationSuccess && !hasUnsavedUserResponses) || isPreview;

        if (showDeliverButton) {
            return (
                <div className={styles.submitButtons}>
                    {
                        deliveringState.actionInProgress === deliveringActions.progressActions.SUBMIT ?
                            <button id="deliverTest" className={btnActiveClassName} disabled>
                                <i
                                    className="fa fa-spinner fa-spin fa-fw"
                                    aria-hidden="true"
                                />{t('delivering.deliverTestButton_delivering')}
                            </button>
                            :
                            <DeliverButton
                                buttonsDisabled={buttonsDisabled}
                                isOnline={isOnline}
                                ui={ui}
                                timeHasExpired={timeHasExpired}
                                noAttemptedQuestions={noAttemptedQuestions}
                            />
                    }
                </div>
            );
        } else if (deliveringState.responseVerificationSuccess === false) {
            return (
                <div>
                    <p>
                        {t('delivering.stateServerDidNotMatch')}
                    </p>
                </div>
            );
        } else if (!isOnline) {
            return (
                <div className={styles.submitButtons}>
                    <DeliverButton
                        buttonsDisabled={buttonsDisabled}
                        isOnline={isOnline}
                        ui={ui}
                        timeHasExpired={timeHasExpired}
                    />
                </div>
            );
        } else if (process.env.NODE_ENV === environmentNames.DEVELOPMENT && sessionReader.isParentTest()) {
            return (
                <button
                    onClick={this.stubDeliverChildTest}
                    id="mockDeliverChildTestButton"
                    className="btn"
                >
                    <i className="fa fa-paper-plane-o fa-fw" aria-hidden="true" />&nbsp;
                    {t('delivering.deliverTestButton')}
                </button>
            );
        }

        return (
            <p>
                <i className="fa fa-spinner fa-pulse fa-3x fa-fw margin-bottom" />
            </p>
        );
    }
}

function mapStateToProps(state) {
    return {
        deliveringState: state.delivering,
        hasUnsavedUserResponses: apiReader.hasUnsavedUserResponses(),
        isOnline: state.api.isOnline,
        timeHasExpired: timeReader.timeHasExpired(state),
        ui: state.ui,
    };
}

const SubmitAssessmentContainer = connect(mapStateToProps)(SubmitAssessment);
export default SubmitAssessmentContainer;
